// extracted by mini-css-extract-plugin
export default {"Container":"ChargePointDetailsTab_Container__Pw3UO","ChargePointTitle":"ChargePointDetailsTab_ChargePointTitle__N+SlQ"};